import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CheckIndicator from '../checkindicator/CheckIndicator'
import MainButton from '../common/util/input/MainButton'
import { getBoostAction } from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'
import { useSharedState } from '../waxplorer/Waxplorer'

function BundlePopup(props) {
    const assets = props['assets']

    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const closeCallBack = props['closeCallBack']
    const [errors, setErrors] = useState({})
    const [sold, setSold] = useState([])
    const [transactions, setTransactions] = useState({})
    const offer = props['offer']

    const addError = (assetId, e) => {
        errors[assetId] = e
        setErrors(errors)
    }

    const addTransaction = (assetId, tx) => {
        transactions[assetId] = tx
        setTransactions(transactions)
    }

    const sell = async () => {
        setIsLoading(true)

        let transferError = null

        const atomicAssetIds = []
        const simpleAssetIds = []
        const actions = [getBoostAction(activeUser)]

        Object.keys(assets).map((assetId) => {
            const asset = assets[assetId]

            if (asset.contract === 'atomicassets')
                atomicAssetIds.push(asset.assetId)
            else if (asset.contract === 'simpleassets')
                simpleAssetIds.push(asset.assetId)
        })

        if (atomicAssetIds.length > 0) {
            actions.push({
                account: 'atomicmarket',
                name: 'announcesale',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    seller: userName,
                    maker_marketplace:
                        process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                            ? 'nfthiveboost'
                            : 'nft.hive',
                    settlement_symbol: '8,WAX',
                    asset_ids: atomicAssetIds,
                    listing_price: parseFloat(offer).toFixed(8) + ' WAX',
                },
            })
            actions.push({
                account: 'atomicassets',
                name: 'createoffer',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    sender: userName,
                    recipient: 'atomicmarket',
                    sender_asset_ids: atomicAssetIds,
                    recipient_asset_ids: [],
                    memo: 'sale',
                },
            })
        }

        if (simpleAssetIds.length > 0) {
            actions.push({
                account: 'waxplorercom',
                name: 'announcesale',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    seller: userName,
                    asset_ids: simpleAssetIds,
                    listing_price: parseFloat(offer).toFixed(8) + ' WAX',
                },
            })
            actions.push({
                account: 'simpleassets',
                name: 'transfer',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser.requestPermission
                            ? activeUser.requestPermission
                            : 'active',
                    },
                ],
                data: {
                    from: userName,
                    to: 'waxplorercom',
                    assetids: simpleAssetIds,
                    memo: 'sale',
                },
            })
        }

        try {
            const result = await activeUser.session.transact(
                {
                    actions: actions,
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            Object.keys(assets)
                .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                .map((assetId) =>
                    addTransaction(
                        assetId,
                        result['response']['transaction_id'],
                    ),
                )
        } catch (e) {
            Object.keys(assets).map((assetId) => addError(assetId, e.message))
            console.error(e)
            setError(e.message)
            transferError = e
        } finally {
            if (!error && !transferError) {
                Object.keys(assets)
                    .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                    .map((assetId) => sold.push(assets[assetId]))
                setSold(sold)
            }
        }
        setIsLoading(false)
        callBack({
            bundled: sold,
            errors: errors,
            transactionIds: transactions,
        })
    }

    let sellInfo = t('asset.sell')

    const sellField = (
        <MainButton className="w-[80px] max-w-32" onClick={sell}>
            {sellInfo}
        </MainButton>
    )

    const cancel = () => {
        callBack({
            bundled: sold,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    return (
        <Popup title={t('search.bundle')} cancel={cancel}>
            <div className="p-2 ">
                {Object.keys(sold).length > 0 ? <CheckIndicator /> : ''}
                {Object.keys(sold).length === 0 ? (
                    <div className="mx-auto mb-4 text-lg font-bold text-center">
                        {t(
                            'popups.are_you_sure_you_want_to_sell_asset_for_amount',
                            {
                                asset: `${
                                    Object.keys(assets).length
                                } Assets in a Bundle`,
                                amount: `${offer} WAX`,
                            },
                        )}
                    </div>
                ) : (
                    ''
                )}
                {error ? <ErrorMessage error={error} /> : ''}
                {Object.keys(sold).length === 0 ? (
                    <div className="relative flex justify-center gap-2">
                        <MainButton onClick={cancel} className="bg-red-500 ">
                            {t('asset.cancel')}
                        </MainButton>
                        {sellField}
                    </div>
                ) : (
                    ''
                )}
                {isLoading ? (
                    <PopupLoadingIndicator
                        text={t('popups.loading_transaction')}
                        isLoading={isLoading}
                    />
                ) : (
                    ''
                )}
            </div>
        </Popup>
    )
}

export default BundlePopup
